<template>
    <div class="chart">
        <div class="pb-3" v-if="selectedFundingIcs && selectedFundingIcs.length > 0">
            <span class="fw-bold me-2 pb-3">Selected Funding ICs: </span><span>{{ selectedFundingIcs.join(", ") }}</span>
        </div>
        <div id="noChartData">No data found</div>
        <div class="chart__main py-2" ref="chartMain" id="mainChart"></div>
    </div>
</template>

<script>
import bus from '@/shared/event-bus.js';
export default {
    name: 'Chart',
    props: {
        data: {
            required: true
        },
        columnHeaders: {
            required: true
        },
        customChartOptions: {
            type: Object,
            required: false
        },
        arraYears: {
            required: true
        },
        rowMetaData: {
            required: true
        },
        chartTitle: {
            required: false
        }
    },
    watch: {
        data: function () {
            this.buildChart(false);
        }
    },
    data: function () {
        return {
            init: false,
            chart: null,
            chartData: null,
            chartAxisLabelsX: [],
            dataActual: [],
            dataEstimated: [],
            dataActualWithARRAs: [],
            lineSymbolSize: 10,
            chartOptions: null,
            selectedFundingIcs: null
        };
    },
    mounted () {
        bus.$on('chart:reloadForFundingIC', async (reloadData, fundingICs) => {
            $("#noChartData").hide();
            $("#mainChart").show();
            this.selectedFundingIcs = fundingICs;
            if (reloadData.length > 0) {
                this.reloadForFundingIC(reloadData);
            } else {
                $("#mainChart").hide();
                $("#noChartData").show();
            }
        });
        
        this.buildChart(false);

        bus.$off('chart:export');
        bus.$on('chart:export', async () => {
            $("#exportContainer").append('<div class="chart_export py-2" id="exportChart"></div>');
            this.$nextTick(() => {
                this.setChartOptions(true);
                this.drawChart(true);
                setTimeout(() => {
                    this.saveChartImage();
                }, 1501);
            });
        });
        
        bus.$on('reset:selectedFundingIcs', () => {
            this.selectedFundingIcs = [];
        });
    },
    methods: {
        reloadForFundingIC (reloadData) {
            this.dataActual = [];
            this.dataActualWithARRAs = [];
            this.dataEstimated = [];
            this.chartAxisLabelsX.forEach(data => {
                let record = _.find(reloadData, (item) => {
                    if (data.toString() === item.fy.toString() && item.arra == 'N') {
                        return item;
                    }
                });
                if (!record) {
                    this.dataActual.push(null);
                } else {
                    this.dataActual.push(record.amount);
                }
            });
            this.chartAxisLabelsX.forEach(data => {
                let record = _.find(reloadData, (item) => {
                    if (data.toString() === item.fy.toString() && item.arra == 'Y') {
                        return item;
                    }
                });
                if (!record) {
                    this.dataActualWithARRAs.push(null);
                } else {
                    this.dataActualWithARRAs.push(record.amount);
                }
            });
            for(let i = 0; i < this.dataActualWithARRAs.length-1; i++) {
                if ( this.dataActualWithARRAs[i]  !== null) {
                    this.dataActualWithARRAs[i] += this.dataActual[i];
                }
                else if ( this.dataActualWithARRAs[i] == null && this.dataActualWithARRAs[i+1] !== null) {
                    this.dataActualWithARRAs[i] = this.dataActual[i];
                } else if (this.dataActualWithARRAs[i] == null && this.dataActualWithARRAs[i-1] === null) {
                    this.dataActualWithARRAs[i-1] = this.dataActual[i-1];
                }
            } 
            this.setChartOptions();
            this.drawChart();
        },

        parseData () {
            // start indexes at one to ignore title column
            var startIndex = 1,
                dataLength = this.rowMetaData.length,
                i,
                cellVal, prevCellVal;

            this.dataActual = [];
            this.dataEstimated = [];
            this.dataActualWithARRAs = [];
            this.chartAxisLabelsX = [];

            for ( i = startIndex; i < dataLength; i++) {
                cellVal = this.data[this.rowMetaData[i].key];
                if (!this.rowMetaData[i].isARRA && !this.rowMetaData[i].isEstimated && !this.rowMetaData[i].isMortality && !this.rowMetaData[i].isPrevalence) {
                    if (cellVal === 0 || cellVal === null) {
                        this.dataActual.push(null);
                    } else {
                        this.dataActual.push(cellVal * 1000000);
                    }
                    this.dataEstimated.push(null);
                    this.chartAxisLabelsX.push(this.rowMetaData[i].key.match(/\d+/)[0]);
                    if (!this.rowMetaData[i+1].isARRA ) {
                        if (cellVal === 0 || cellVal === null) {
                            this.dataActualWithARRAs.push(null);
                        } else {
                            this.dataActualWithARRAs.push(cellVal * 1000000);
                        }
                    }
                }
                else if (this.rowMetaData[i].isEstimated) {
                    if (cellVal === 0 || cellVal === null) {
                        this.dataEstimated.push(null);
                    } else {
                        this.dataEstimated.push(cellVal * 1000000);
                    }
                    this.chartAxisLabelsX.push(this.rowMetaData[i].key.match(/\d+/)[0]);
                }
                else if (this.rowMetaData[i].isARRA) {
                    if (cellVal) {
                        prevCellVal = (cellVal * 1000000) + (this.data[this.rowMetaData[i-1].key]  * 1000000);

                        this.dataActualWithARRAs.push(prevCellVal);
                    } else {
                        this.dataActualWithARRAs.push(null);
                    }
                }
            }

            for ( i = this.dataEstimated.length; i >= 0 ; i--) {
                if (this.dataEstimated[i] === null) {
                    this.dataEstimated[i] = this.dataActual[i];
                    break;
                }
            }

        },

        setChartOptions (isExport) {
            let fundingICText = '';
            if (this.selectedFundingIcs && this.selectedFundingIcs.length > 0) {
                fundingICText = "Funding ICs: " + this.selectedFundingIcs.join(", ");
            }
            this.chartOptions = {
                title: {
                    text: this.chartTitle,
                    subtext: fundingICText,
                    left: '2%',
                    itemGap: 3,
                    show: isExport && this.chartTitle ? true : false,
                    textStyle: {
                        color: '#0566b1',
                        fontSize: '2rem'
                    },
                    subtextStyle: {
                        fontWeight: 'bold',
                        fontSize: '12px',
                        color: '#505050'
                    }
                },
                grid: {
                    borderColor: '#ccc' ,
                    left: '65',
                    right: 5,
                    bottom: 35,
                    top: isExport ? (fundingICText != '' ? '33%' : '28%') : '15%'
                },
                legend: {
                    show: true,
                    type: 'plain',
                    left: '6%',
                    top: isExport ? (fundingICText != '' ? '20%' : '15%') : '-1%',
                    selectedMode: false
                },
                tooltip: {
                    confine: true,
                    trigger: 'item',
                    // triggerOn: 'click',
                    axisPointer: {
                        shadowStyle: {
                            color: 'rgba(8, 130, 220, 0.1)'
                        },
                        type: 'shadow',
                        z: '0',
                    },
                    formatter: (params) => {
                        if (this.$parent.activeColumn !== params.axisValue) {
                            this.$parent.activeColumn = params.axisValue;
                        }

                        let tooltip = params.name + '<br> ';

                        for (let i = 0; i < this.chartOptions.series.length; i++) {
                            if (this.chartOptions.series[i].data[params.dataIndex] && !(i > 0 && (this.chartOptions.series[i].data[params.dataIndex] === this.chartOptions.series[0].data[params.dataIndex]))) {
                                tooltip +=  this.chartOptions.series[i].name + ': ' + window.formatLargeCurrency(this.chartOptions.series[i].data[params.dataIndex]) + '</br>';
                            }
                        }

                        return tooltip;
                    }
                },
                xAxis: {
                    type: 'category',
                    data: this.chartAxisLabelsX,
                    axisLabel: {
                        fontWeight: 'bold',
                        color: '#555',
                        fontSize: '13'
                    }
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 3,
                    axisLabel: {
                        fontWeight: 'bold',
                        color: '#555',
                        fontSize: '13',
                        formatter: (value) => {
                            if (value && value[0] !== '$') {
                                return window.formatLargeCurrency(value);
                            } else {
                                return value;
                            }
                        }
                    }
                },
                color: ['#0062B0', '#ED7D2F', '#FFC012'],
                backgroundColor: '#fff',
                series: [
                    {
                        data: this.dataActual,
                        name: 'Actual',
                        type: 'line',
                        symbolSize: 8,
                        lineStyle: {
                            width: 4
                        },
                        itemStyle: {
                            borderWidth: 4
                        },
                        z: 6
                    },
                    {
                        data: this.dataActualWithARRAs,
                        name: 'Actual With ARRA',
                        type: 'line',
                        symbolSize: 8,
                        lineStyle: {
                            width: 4
                        },
                        itemStyle: {
                            borderWidth: 4
                        },
                        z: 5
                    },
                    {
                        data: this.dataEstimated,
                        name: 'Estimated',
                        type: 'line',
                        symbolSize: 8,
                        lineStyle: {
                            width: 4,
                            type: 'dotted'
                        },
                        itemStyle: {
                            borderWidth: 4
                        },
                        z: 2
                    }
                ]
            };
        },

        drawChart (isExport) {
            $("#mainChart").show();
            let chartContainer = this.$refs.chartMain;
            if (isExport) {
                chartContainer = $("#exportChart")[0];
            } 
            this.chart = echarts.init(chartContainer);
            this.chart.setOption(this.chartOptions);
        },

        buildChart (isExport) {
            $("#noChartData").hide();
            this.parseData();
            this.setChartOptions(isExport);
            this.drawChart(isExport);

            if (!isExport) {
                this.$refs.chartMain.addEventListener('mouseout', () => {
                    this.$parent.activeColumn = null;
                });
            }
        },

        resizeChart () {
            if (this.chart) {
                this.chart.resize();
            }
        },

        saveChartImage () {
            let canvasElement = document.querySelector('#exportChart canvas'),
                MIME_TYPE = "image/png",
                imgURL = canvasElement.toDataURL(MIME_TYPE);

            let dlLink = document.createElement('a');
            dlLink.download = this.chartTitle.replace(/\s/ig, '-');
            dlLink.href = imgURL;
            dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(':');

            document.body.appendChild(dlLink);
            dlLink.click();
            document.body.removeChild(dlLink);
           // $('#exportContainer').empty();
        }
    }
};
</script>

<style lang="scss">
.chart,
.chart__main {
    width: 99%;
    margin: 0 auto;
    height: 325px;
}
.chart_export {
    width: 100%;
    height: 350px;
}
</style>